var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader row"},[_c('div',{staticClass:"preloader-logo d-inline-flex mx-auto"},[_c('img',{attrs:{"src":require(`../../img/${_vm.brand_slug}/logo.svg`)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }